import { isRouteErrorResponse, useRouteError } from "react-router-dom";

import "./style.less";

export function ErrorBoundary() {
  const error = useRouteError();
  console.error("[ErrorBoundary]", error);

  let title = "Algo deu errado";
  let content = "Ocorreu um erro inesperado.";
  if (isRouteErrorResponse(error)) {
    title = `${error.status} ${error.statusText}`;
    // prettier-ignore
    content = typeof error.data === "string"
      ? error.data
      : JSON.stringify(error.data);
  } else if (error instanceof Error) {
    title = error.name;
    content = error.message;
  } else if (typeof error === "string") {
    content = error;
  }

  return (
    <div className="ErrorBoundary-template">
      <h1>{title}</h1>
      <pre>{content}</pre>
    </div>
  );
}
